import { render, staticRenderFns } from "./claimsSettlementProject.vue?vue&type=template&id=7419fabe&scoped=true&"
import script from "./claimsSettlementProject.vue?vue&type=script&lang=js&"
export * from "./claimsSettlementProject.vue?vue&type=script&lang=js&"
import style0 from "./claimsSettlementProject.vue?vue&type=style&index=0&id=7419fabe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7419fabe",
  null
  
)

export default component.exports